var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkExternal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link-external-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M21.7441 9.5L21.7441 3.5M21.7441 3.5H15.7441M21.7441 3.5L13.7441 11.5M10.7441 5.5H8.54414C6.86398 5.5 6.0239 5.5 5.38217 5.82698C4.81768 6.1146 4.35874 6.57354 4.07112 7.13803C3.74414 7.77976 3.74414 8.61984 3.74414 10.3V16.7C3.74414 18.3802 3.74414 19.2202 4.07112 19.862C4.35874 20.4265 4.81768 20.8854 5.38217 21.173C6.0239 21.5 6.86398 21.5 8.54414 21.5H14.9441C16.6243 21.5 17.4644 21.5 18.1061 21.173C18.6706 20.8854 19.1295 20.4265 19.4172 19.862C19.7441 19.2202 19.7441 18.3802 19.7441 16.7V14.5",
    stroke: "#38cb89",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkExternal);
export default __webpack_public_path__ + "static/media/link-external.2a77b5ae9d3edb06acbc7c0b34941c09.svg";
export { ForwardRef as ReactComponent };